import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { type AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import { type SplitSupplyNoticeSection } from '@ebalance/proto/bffuser/v1/split_supply_plan_model_pb'
import { listOwnSplitSupplyNotices } from '@ebalance/proto/bffuser/v1/split_supply_plan_service-SplitSupplyPlanService_connectquery'
import {
  ListOwnSplitSupplyNoticesRequestSchema,
  type ListOwnSplitSupplyNoticesResponse,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

import { type CivilDate, civilDateToProtoDate } from '~/models/civilDate'

type Params = {
  section: SplitSupplyNoticeSection
  /** 翌日の通は受渡日、 月間の通は対象月の 1 日。 */
  targetDate: CivilDate
  /** 未指定 = すべてのエリア。 */
  areaCode: AreaCode | undefined
}

/**
 * 自社の通告値の一覧 (1 行 = 電文 1 通) の取得 hook。
 */
export function useListOwnSplitSupplyNotices({
  section,
  targetDate,
  areaCode,
}: Params): UseQueryResult<ListOwnSplitSupplyNoticesResponse, ConnectError> {
  return useQuery(
    listOwnSplitSupplyNotices,
    create(ListOwnSplitSupplyNoticesRequestSchema, {
      section,
      targetDate: civilDateToProtoDate(targetDate),
      areaCode,
    }),
    // 本番の既定は throwOnError: true。 一覧の失敗は表の位置の案内 (再試行つき) で見せるので伝播させない
    { throwOnError: false },
  )
}
